module.exports = __webpack_public_path__ + "assets/img/1_578_big.bd43079a.jpg";